import React, { useState, useMemo } from 'react'
import { LastUpdatedDetails, getFormattedDate, getUpdatedTime } from "views/pages/manage/employeeManagement/userProfile/helper";
import { getStatusChipInfo } from "modules/studentTransfer/transferApproval/utils";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import ServerDataGrid from 'views/pages/manage/common/data-grid/ServerDataGrid';
import ALoader from 'views/pages/manage/common/a-loader';
import { Card, CardBody, Col, Row } from 'reactstrap'
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";
import { Box, Tooltip } from "@mui/material";
import { statusMapping, statusStyle } from '../../../studentView/constant';

const Logs = ({
  rows,
  paginationInfo,
  loader,
  setLoader,
}) => {

  const [open, setOpen] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });


  const columns = useMemo(() => [
    {
      key: "action",
      sortable: true,
      label: "Events",
      width: 120,
      render: (value) => (
        value ? <Tooltip title={value}><div className="ellipsis-text-container">{value}</div></Tooltip> : <div>-</div>
      )
    },
    {
      key: "updatedOn",
      sortable: true,
      label: "Last updated on",
      width: 120,
      render: (value, row) => {
        const display = LastUpdatedDetails(value, row.updatedBy);
        return value ? <Tooltip title={display}><div className="ellipsis-text-container">{display}</div></Tooltip> : <div>-</div>
      }
    },
    {
      key: "status",
      sortable: true,
      label: "Status",
      width: 80,
      align: "center",
      render: (value, row) => (
        value ? <Tooltip title={statusMapping?.[(value).toUpperCase()] ?? (value).toUpperCase()}>
          <div className={`ellipsis-text-container`} style={statusStyle?.[statusMapping?.[(value).toUpperCase()]]}>{statusMapping?.[(value).toUpperCase()] ?? (value).toUpperCase()}</div>
        </Tooltip> : <div>-</div>
      )
    },
  ], [setLoader]);

  return (
    <Card>
      <CardBody>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='dark-text label-color'>Logs</div>
          <div className="cursor" onClick={() => { setOpen((prev) => (!prev)) }}>{open ? <Uparrow /> : <DownArrow />}</div>
        </div>
        {open && <><div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
          {loader && <ALoader position="fixed" />}
          <ServerDataGrid
            rows={rows || []}
            loading={false}
            columns={columns}
            rowKey="id"
            height="250px"
            hidePagination={true}
          />
        </>}
      </CardBody>
    </Card>
  )
}

export default Logs